// biome-ignore lint/style/useImportType: legacy import, will be migrated
import {
  getG11nAndTranslationsFromServer,
  initializeApollo,
  TCustomGetServerSideProps,
} from '@crehana/next';

// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { IAppProps } from '@/views/Homepage/types';

import localeViewEn from '../../../i18n/localeEn';
import localeViewEs from '../../../i18n/localeEs';
import localeViewPt from '../../../i18n/localePt';
import { PAGE_KEY } from '../contants';
import localeEn from '../i18n/localeEn';
import localeEs from '../i18n/localeEs';
import localePt from '../i18n/localePt';

const getServerSideProps: TCustomGetServerSideProps<IAppProps> = async ({
  req,
}) => {
  const apolloClient = initializeApollo();
  const g11nData = await getG11nAndTranslationsFromServer({
    headers: req.headers,
    pageKey: PAGE_KEY,
    defaultTranslations: {
      es: { [PAGE_KEY]: { ...localeEs.es, ...localeViewEs.es } },
      pt: { [PAGE_KEY]: { ...localePt.pt, ...localeViewPt.pt } },
      en: { [PAGE_KEY]: { ...localeEn.en, ...localeViewEn.en } },
    },
  });

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      ...g11nData,
      // NOTE: FreeTrial page doesn't have the organization slug but we need it to be sent to the app.
      organizationSlug: '',
    },
  };
};

export default getServerSideProps;
